import "./Posts.css";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import sanityClient from "../../sanityClient";
import { postQuery } from "../../queries/postQuery";
import PortableTextComponent from "../../components/PortableText/PortableText";
import { StandardLayout } from "../../layouts/StandardLayout";
import { convertDateFormat } from "../../utility/dateFormat";
import { FaUser } from "react-icons/fa6";

export default function SinglePost() {
    const [postData, setPostData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { slug } = useParams();

    useEffect(() => {
        if (!slug) return;

        setIsLoading(true);
        sanityClient
            .fetch(postQuery, { slug })
            .then((data) => {
                if (data) {
                    setPostData(data);
                } else {
                    setError("Post not found.");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setError("Failed to fetch post.");
                setIsLoading(false);
            });
    }, [slug]);

    // let displayLocation = 'block';
    // if(post.location === 'none'){
    //     displayLocation = 'none';
    // }

    if (isLoading) {
        return <StandardLayout title="Loading..." content="Loading..." />;
    }

    if (error) {
        return <StandardLayout title="Error" content={error} />;
    }

    if (!postData) {
        return <StandardLayout title="Not Found" content="This post could not be found." />;
    }

    const content = (
        <div className="postContainer">
            <div className="post">
                <Link className="postCategory" to={`/categories/${postData.category.slug.current}`}>
                    <h4>{postData.category.title}</h4>
                </Link>
                <h3 className="postTitle">{postData.title}</h3>
                <h4 className="postLocation">{`${postData.location.city}, ${postData.location.state}`}</h4>

                <div className="postUsernameAndDate">
                    <h4>
                        <FaUser /> {postData.username} | {convertDateFormat(postData.date)}
                    </h4>
                </div>

                <PortableTextComponent content={postData.body} />
                {/* <img style={{display: displayImage}} src={post?.image?.src} alt={post?.image?.alt} /> */}
            </div>
            <h4 className="postByline">
                by{" "}
                <Link className="postContributorLink" to={`/contributors/${postData.contributor.slug.current}`}>
                    {postData.contributor.name}
                </Link>
            </h4>
        </div>
    );

    return <StandardLayout title={postData.title} content={content} />;
}
